export const DISABLED_FIELD_SX = {
  cursor: "not-allowed",
  backgroundColor: "#eef2f7",
  "&.Mui-disabled": {
    opacity: 1,
    backgroundColor: "#eef2f7",
    color: "#475569",
    WebkitTextFillColor: "#475569",
  },
  "&.Mui-disabled .MuiSelect-select": {
    color: "#475569",
    WebkitTextFillColor: "#475569",
  },
  "&.Mui-disabled .MuiInputBase-input": {
    color: "#475569",
    WebkitTextFillColor: "#475569",
  },
  "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#94a3b8",
  },
  "&.Mui-disabled svg": {
    color: "#94a3b8",
    opacity: 1,
  },
};

export const DISABLED_BUTTON_SX = {
  "&.Mui-disabled": {
    opacity: 1,
    color: "#64748b",
    borderColor: "#94a3b8",
    backgroundColor: "#eef2f7",
  },
};

export const DISABLED_OUTLINED_INPUT_SX = {
  "& .MuiOutlinedInput-root.Mui-disabled": {
    opacity: 1,
    backgroundColor: "#eef2f7",
    cursor: "not-allowed",
  },
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#94a3b8",
  },
  "& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input": {
    color: "#475569",
    WebkitTextFillColor: "#475569",
  },
};
